
export { default as BandageFillIcon } from "./BandageFill.js"
export { default as BandageIcon } from "./Bandage.js"